import React from "react";
import { Typography } from "@bca/ui-library";

import OwnersRegularSVG from "./Icons/OwnersRegularSVG";
import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import { KeyDecisionMakerText } from "./mechanicalReport/styledElements/KeyDecisionMakerText";

const Owners: React.FunctionComponent<{ ownersCount: string }> = ({
  ownersCount,
}) => {
  const owners = !ownersCount || ownersCount === "-" ? "-" : ownersCount;

  return (
    <KeyDecisionMakerContainer>
      <KeyDecisionMakerText>
        <OwnersRegularSVG width="24px" height="24px" />
        <Typography
          m={0}
          variant="h6"
          fontWeight="semiBold"
          color="footer-blue"
        >
          {owners}
        </Typography>
      </KeyDecisionMakerText>
      <Typography
        variant="body-small"
        color="grey-blue"
        m={0}
        textAlign="center"
      >
        {ownersCount !== "1" ? "Owners" : "Owner"}
      </Typography>
    </KeyDecisionMakerContainer>
  );
};

export default Owners;
